import loadable from '@loadable/component'

export default {
  '/lt-exercise': loadable(() => import('./LtExercise')),
  '/:any/login': loadable(() => import('./Login')),
  '/w/qrlogin': loadable(() => import('./Login')),
  // '/w/downloadpc': loadable(() => import('./DownloadApp')),
  '/w/downloadpc': loadable(() => import('./DownloadNew')),
  '/w/about': loadable(() => import('./About')),
  '/:any/': loadable(() => import('./Home')),
  '/': loadable(() => import('./Home'))
}
